import styled from 'styled-components';

const StyledLoader = styled.div<{ size?: number }>`
  &:after {
    content: ' ';
    display: block;
    width: ${({ size }) => size || 30}px;
    height: ${({ size }) => size || 30}px;
    border-radius: 50%;
    border: 4px solid #2ac4fb;
    border-color: #2ac4fb transparent #2ac4fb transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }

  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default StyledLoader;
